import { takeLatest, call, put } from 'redux-saga/effects';
import {
    getPatientConsentSuccess, getPatientConsentFailure,
    postPatientConsentSuccess, postPatientConsentFailure,
    uploadPatientConsentSuccess, uploadPatientConsentFailure,
} from './slice';
import { apiGet, apiPost, apiUpload } from '../../../../api/client';

function* getPatientConsentRequest(action) {
    try {
        const response = yield call(apiGet, `api/get-patient-consent/${action.payload.pId}`);
        yield put(getPatientConsentSuccess(response));
    } catch (error) {
        yield put(getPatientConsentFailure(error?.response?.message || error));
    }
}

function* postPatientConsentRequest(action) {
    try {
        const response = yield call(apiPost, 'api/post-patient-consent', action.payload);
        yield put(postPatientConsentSuccess(response));
    } catch (error) {
        yield put(postPatientConsentFailure(error?.response?.message || error));
    }
}

function* uploadPatientConsentRequest(action) {
    try {
        const { pId, branchId, file } = action.payload;
        const form = new FormData();
        // Plain fields must be appended before the file so multer has
        // parsed them by the time the file part is processed.
        form.append('pId', pId);
        if (branchId) form.append('branchId', branchId);
        form.append('file', file);
        const response = yield call(apiUpload, 'api/upload-patient-consent', form);
        yield put(uploadPatientConsentSuccess(response));
    } catch (error) {
        yield put(uploadPatientConsentFailure(error?.response?.message || error));
    }
}

function* saga() {
    yield takeLatest('patientConsent/getPatientConsentRequest', getPatientConsentRequest);
    yield takeLatest('patientConsent/postPatientConsentRequest', postPatientConsentRequest);
    yield takeLatest('patientConsent/uploadPatientConsentRequest', uploadPatientConsentRequest);
}

export default saga;
